import moment from "moment-timezone";
import { api } from "services/restUtil";
import {
  AccessObject,
  PaymentStatus,
  SubscriptionPlan,
} from "services/subscriptions/model";
import { apiQuery } from "utils/queries";

export interface SubscriptionPlanResponse {
  subscription: SubscriptionPlan | null;
  access_object: AccessObject | null;
  payment: PaymentStatus | null;
}

export const currentSubscriptionPlanQuery = apiQuery({
  key: "/subscription/plan",
  queryFn: () => api.get<SubscriptionPlanResponse>("/subscription/plan"),
});

export function deleteSubscriptionPlan() {
  return api.delete<void, SubscriptionPlan>("/subscription/plan");
}

// Return a number of days (including grace period) user has access to pro content.
export function getDaysWithinGracePeriod(
  subscription: SubscriptionPlan,
  timezoneId: string
) {
  const dueDate = subscription.next_payment?.due_date;
  const gracePeriod =
    (subscription.next_payment?.grace_period &&
      Math.trunc(subscription.next_payment.grace_period / 24)) ||
    0;
  const tzAdjustedDueDate = moment.tz(dueDate, timezoneId);
  return tzAdjustedDueDate.diff(moment.tz(timezoneId), "days") + gracePeriod;
}
